export default __webpack_public_path__ + "static/media/end2img.b9e08cf3.png";